import React, {useContext, useEffect} from "react";
import {Col} from "../../../../styles/Grid";
import styled from "styled-components";
import parse from "html-react-parser";
import {FacilitatorsContext} from "../../../../context/FacilitatorsProvider";
import {SelectStyled} from "../../../../styles/Forms";
import {AcademyContext} from "../../../../context/AcademyProvider";
import {LoadComponet} from "../../../../components/loaders/Loader";
import {EssentialContext} from "../../../../context/EssentialProvider";
import {HomeContext} from "../../../../context/HomeProvider";

export default function TypeSelects({type, data, current, change}) {
   const {visibleList} = useContext(FacilitatorsContext);
   const {allCourse, getAllCoursesList} = useContext(EssentialContext);
   const {academyList, getList} = useContext(AcademyContext);
   const {getTestimonials, testimonialsList} = useContext(HomeContext);

   useEffect(() => {
      getList();
      getAllCoursesList();
      getTestimonials();
   }, []);

   switch (type) {
      case "Facilitators":
         return (
            <Col large={12} className="element">
               <SelectStyled name="idReference" onChange={change} defaultValue={current}>
                  {React.Children.toArray(
                     visibleList.map((item) => {
                        return <option value={item.idFacilitator}>{item.facilitatorName + " " + item.facilitatorLastName}</option>;
                     }),
                  )}
               </SelectStyled>
            </Col>
         );
      case "Courses":
         return (
            <Col large={12} className="element">
               {!allCourse ? (
                  <LoadComponet isVisible={true} />
               ) : (
                  <SelectStyled name="idReference" onChange={change} defaultValue={current}>
                     {React.Children.toArray(
                        allCourse.map((item) => {
                           return <option value={item.idCourse}>{item.courseName}</option>;
                        }),
                     )}
                  </SelectStyled>
               )}
            </Col>
         );
      case "Testimonials":
         return (
            <Col large={12} className="element">
               {!testimonialsList.length === 0 ? (
                  <LoadComponet isVisible={true} />
               ) : (
                  <SelectStyled name="idReference" onChange={change} defaultValue={current}>
                     {React.Children.toArray(
                        testimonialsList.map((item) => {
                           return <option value={item.idTestitmonial}>{item.title} asas</option>;
                        }),
                     )}
                  </SelectStyled>
               )}
            </Col>
         );
      case "DomeqAcademy":
         return (
            <Col large={12} className="element">
               <SelectStyled name="idReference" onChange={change} defaultValue={current }>
               {/* <option value={item.idTestitmonial}>{item.title} asas</option> */}
                  {React.Children.toArray(
                     academyList.map((item) => {
                        // console.log(item)
                        return <option value={item.idDomecqAcademyContent}>{returnTypeAcademy(item.idDomecqAcademyContent)}</option>;
                     }),
                  )}
               </SelectStyled>
            </Col>
         );
      default:
         return <p>{type}</p>;
   }
}

let returnTypeAcademy = (id) => {
   switch (id) {
      case 1:
         return "Portada Web";
      case 2:
         return "Bienvenida";
      case 3:
         return "Programas de formación";
      case 4:
         return "Facilitadores";
      case 5:
         return "Instalaciones";
      default:
         return "";
   }
};

const ReadEl = styled.div`
   box-sizing: border-box;
   margin-right: 1em;
   backround: red;

   p,
   select {
      font-weight: 300;
      font-size: 0.9em;
      margin: 0;
      background-color: transparent;
   }
   select {
      margin-bottom: 1 em;
   }
   p {
      margin: 0.5em;
   }
`;
